module.exports = __webpack_public_path__ + "media/src/images/store-not-image-97dce92951bfcd338e7ed7ea494162e2.png";